import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pulse_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("pulse_token");
      localStorage.removeItem("pulse_user");
    }
    // 412 signature_required → save current path and redirect to Profile
    if (err?.response?.status === 412 && err?.response?.data?.detail?.error === "signature_required") {
      try {
        localStorage.setItem("pulse_post_profile_redirect", window.location.pathname + window.location.search);
        if (!window.location.pathname.startsWith("/profile")) {
          window.location.assign("/profile?reason=signature_required");
        }
      } catch { /* noop */ }
    }
    return Promise.reject(err);
  }
);

export default api;
